export const UPDATED_REVIEWS = 'UPDATED_REVIEWS'

export const LIKE_REVIEW = 'LIKE_REVIEW'
export const UNLIKE_REVIEW = 'UNLIKE_REVIEW'

export const FETCHING_REVIEWS_INDEX = 'FETCHING_REVIEWS_INDEX'
export const RECEIVED_REVIEWS_INDEX = 'RECEIVED_REVIEWS_INDEX'
export const ERROR_FETCHING_REVIEWS_INDEX = 'ERROR_FETCHING_REVIEWS_INDEX'
